/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ContactId} from "./contactId.zod";
import {PhoneNumberDto} from "./phoneNumberDto.zod";

export const ContactDto = zod
  .union([
    zod.object({
      email: zod.string(),
    }),
    zod.object({
      phone: PhoneNumberDto,
    }),
  ])
  .and(
    zod.object({
      contactId: ContactId,
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
      name: zod.string(),
      description: zod.string().nullable(),
      email: zod.string().nullable(),
      phone: zod.union([PhoneNumberDto, zod.null()]),
    }),
  );

export type ContactDto = zod.input<typeof ContactDto>;
export type ContactDtoOutput = zod.output<typeof ContactDto>;
